import React, { FunctionComponent, useState } from 'react';

import { Button, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { ErrorDisplay } from 'social/publisher/error-display/ErrorDisplay';
import { YoutubeFields, PublisherError } from 'social/publisher/Publisher.types';
import { usePublisherDispatch } from 'social/publisher/PublisherContext';

import 'social/publisher/youtube-fields-selector/YoutubeFieldsSelector.scss';

interface Props {
    youtubeFields: YoutubeFields;
    publisherErrors: PublisherError[];
}

export const YoutubeFieldsSelector: FunctionComponent<Props> = ({ youtubeFields, publisherErrors }) => {
    const dispatch = usePublisherDispatch();
    const { t } = useTranslation('social/publisher');
    const [isShowMoreOptions, setIsShowMoreOptions] = useState(false);
    const toggleShowMoreOptions = (): void => {
        if (isShowMoreOptions) {
            setIsShowMoreOptions(false);
        } else {
            setIsShowMoreOptions(true);
        }
    };
    const handleKidsVideoChange = (isKidsVideo: boolean): void => {
        const newFields = { ...youtubeFields };

        newFields.kidsVideo = isKidsVideo;
        dispatch({ type: 'set-youtube-fields', payload: { value: newFields } });
    };
    const handleSaveEmbedVideo = (): void => {
        const newFields = { ...youtubeFields };

        newFields.embedVideo = !youtubeFields.embedVideo;
        dispatch({ type: 'set-youtube-fields', payload: { value: newFields } });
    };
    const handleSavePublishToFeed = (): void => {
        const newFields = { ...youtubeFields };

        newFields.publishToFeed = !youtubeFields.publishToFeed;
        dispatch({ type: 'set-youtube-fields', payload: { value: newFields } });
    };

    return (
        <div className="r4e-social-youtube-fields-editor">
            <ErrorDisplay source="YOUTUBE" component="YOUTUBE_FIELDS" publisherErrors={publisherErrors} />
            <h3 className="youtube-fields-editor-title">
                <Button variant="link" onClick={toggleShowMoreOptions}>
                    {isShowMoreOptions ? t('COLLAPSE_OPTIONS') : t('MORE_OPTIONS')}
                </Button>
            </h3>
            {isShowMoreOptions && (
                <div className="youtube-fields-editor-options">
                    <div className="youtube-fields-editor-option kidsVideo">
                        <h3 className="option-title">{t('IS_VIDEO_FOR_KIDS')}</h3>
                        <Form.Group controlId="kidsVideoTrue">
                            <Form.Check
                                type="radio"
                                label={t('IT_IS_FOR_KIDS')}
                                checked={youtubeFields.kidsVideo}
                                onChange={(): void => handleKidsVideoChange(true)}
                            />
                        </Form.Group>
                        <Form.Group controlId="kidsVideoFalse">
                            <Form.Check
                                type="radio"
                                label={t('IT_IS_NOT_FOR_KIDS')}
                                checked={!youtubeFields.kidsVideo}
                                onChange={(): void => handleKidsVideoChange(false)}
                            />
                        </Form.Group>
                    </div>
                    <div className="youtube-fields-editor-option licence-distribution">
                        <h3 className="option-title">{t('LICENCE_AND_DISTRIBUTION')}</h3>
                        <Form.Group controlId="embedVideo">
                            <Form.Check
                                type="checkbox"
                                label={t('ALLOW_EMBEDDING')}
                                checked={youtubeFields.embedVideo}
                                onChange={handleSaveEmbedVideo}
                            />
                        </Form.Group>
                        <Form.Group controlId="publishToFeed">
                            <Form.Check
                                type="checkbox"
                                label={t('PUBLISH_TO_FEED')}
                                checked={youtubeFields.publishToFeed}
                                onChange={handleSavePublishToFeed}
                            />
                        </Form.Group>
                    </div>
                </div>
            )}
        </div>
    );
};
